import { bl_svc_return_reason_RowCLass } from '../../../dbschema/bl_svc_return_reason.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceReturnReasonContainerModel extends BaseContainerModel {
  bl_svc_return_reason: bl_svc_return_reason_RowCLass = new bl_svc_return_reason_RowCLass();
}
